var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mobile-filter-modal" }, [
    _c("div", { staticClass: "popup" }, [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("div", { staticClass: "title" }, [
            _c("h4", { domProps: { innerHTML: _vm._s(_vm.labels.filterAlt) } }),
            _vm._v(" "),
            _c("a", { staticClass: "cancel", on: { click: _vm.closeFilter } }, [
              _c("i", { staticClass: "far fa-lg fa-times" }),
            ]),
          ]),
          _vm._v(" "),
          _vm._t("default"),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "fixed actions" }, [
        _c("button", {
          staticClass: "confirm",
          domProps: { innerHTML: _vm._s(_vm.labels.applyPlural) },
          on: { click: _vm.applyFilters },
        }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }